exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-body[data-v-aa187afa] {\n  overflow: scroll;\n  height: 65vh;\n}\n", ""]);

// exports
